// import {
//   SET_SUPPLIER_LIST,
// } from '../mutation-types';

export default {

};
